export default "__VITE_ASSET__d0da5b35__"